import React from 'react';
import { Link, Input, Flex } from '@upsales/components';
import type {
	EditWidgetRowProps,
	WidgetDataSourceProps
} from 'App/components/hooks/integrations/externalIntegrationTypes';
import { useTranslation } from 'Components/Helpers/translate';
import WidgetFieldSetting from './helpers/WidgetFieldSetting';
import useTagTranslator from './useTagTranslator';

export const EditUiWidgetLink = ({ row, onUpdate }: EditWidgetRowProps) => {
	const { settings } = row;
	const url = settings?.url || '';
	const text = settings?.text || '';
	const { t } = useTranslation();

	const handleChange = (field: 'url' | 'text') => (e: React.ChangeEvent<HTMLInputElement>) => {
		onUpdate({
			...row,
			settings: {
				...settings,
				[field]: e.target.value
			}
		});
	};

	return (
		<Flex direction="column" gap="u1">
			<WidgetFieldSetting text={t('default.url')}>
				<Input value={url} onChange={handleChange('url')} type="url" />
			</WidgetFieldSetting>

			<WidgetFieldSetting text={t('default.text')}>
				<Input value={text} onChange={handleChange('text')} type="text" />
			</WidgetFieldSetting>
		</Flex>
	);
};

const UiWidgetLink: React.FC<WidgetDataSourceProps> = ({ row, dataSources, widgetSettings }) => {
	const translatedText = useTagTranslator(row.settings, dataSources, widgetSettings);
	const translatedUrl = useTagTranslator(row.settings, dataSources, widgetSettings, 'url');

	return (
		<Flex className="UiWidget__link">
			<Link href={translatedUrl} target="_blank">
				{translatedText || translatedUrl}
			</Link>
		</Flex>
	);
};

export default UiWidgetLink;
